import { render } from "./ReportSyntheticCredit.vue?vue&type=template&id=32d23f18"
import script from "./ReportSyntheticCredit.vue?vue&type=script&lang=js"
export * from "./ReportSyntheticCredit.vue?vue&type=script&lang=js"

import "./ReportSyntheticCredit.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__